import { useCallback } from 'react';
import { timesheetsService } from '../services';
import {
  useResourceCollection,
  ResourceState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Timesheet } from '../types';

export function useTimesheets(
  options?: ResourceQueryOptions
): ResourceState<Timesheet> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      timesheetsService.getAll(opts) as unknown as Promise<{ data: Timesheet[]; meta?: any }>,
    []
  );
  return useResourceCollection<Timesheet>(fetchFn, options);
}

/**
 * Create or update a timesheet record. Crew rows are unique per
 * employee+month; off-crew rows (Office/Visitor/Manpower) send
 * personType/personName instead of an employee.
 */
export async function saveTimesheet(record: {
  documentId?: string;
  id?: string | number;
  employeeId?: string;
  branchId: string;
  month: string;
  days: Record<string, string>;
  description?: string;
  personType?: string;
  personName?: string;
}): Promise<any> {
  const payload: any = {
    employeeId: record.employeeId || null,
    branchId: record.branchId,
    month: record.month,
    days: record.days,
    description: record.description || '',
    personType: record.personType || null,
    personName: record.personName || null,
  };
  if (record.documentId) {
    return timesheetsService.update(record.id as any, { ...payload, documentId: record.documentId });
  }
  return timesheetsService.create(payload);
}
